import { useState, useEffect } from "react";
import { useForm } from 'react-hook-form';
import HeaderBar from "../HeaderBar";
import useStateMachineWrapper, { sendState } from "../../helpers/useStateMachineWrapper";
import ContentButton from "../ContentButton";
import sleep from "../../helpers/sleep";
import Button from "../Button";
import { withHookFormMask } from "use-mask-input";
// import { usePaymentInputs } from 'react-payment-inputs';
import usePaymentInputs from 'react-payment-inputs/es/usePaymentInputs';

import images from 'react-payment-inputs/images';
import { dataLayerPush } from "../../helpers/analytics";

const OrderPayment = (props) => {
  const {actions, state} = useStateMachineWrapper();

  const [isLoading, setIsLoading] = useState(false);

  const [errorMessage, setErrorMessage] = useState({
    title: '',
    message: '',
  });

  const { control, register, handleSubmit, watch, getValues, formState: { errors, isValid, submitCount } } = useForm({
    mode: 'onTouched',
    defaultValues: {
      account: state.session.account,
      routing: state.session.routing,
      bank: state.session.bank,
      type: state.session.type,
      ccard: state.session.ccard,
      exMonth: state.session.exMonth,
      exYear: state.session.exYear,
    },
  });
  watch(['ccard', 'exMonth', 'exYear']);

  const { meta, getCardImageProps, getCardNumberProps, getExpiryDateProps, getCVCProps } = usePaymentInputs();

  const updateData = (data) => {
    actions.update(data);
  }
  const manuallySubmit = async () => {
    setIsLoading(true);

    handleSubmit(updateData)();

    // handleSubmit isn't promise-based so we need to give a slight delay before proceeding otherwise our page might not update correctly
    await sleep(50);

    let _state = state;
    let {page, ..._session} = _state.session;

    _state.session = _session;
    _state.session = {
      ..._state.session,
      ...getValues(),
    };

    _state.session.submitting = true;

    let didSubmit = false;
    try {
      const sendStateResponse = await sendState(_state);
      didSubmit = true;

    } catch(e) {
      didSubmit = false;
      setErrorMessage({...e.response.data});
    }

    setIsLoading(false);

    return didSubmit;
  }

  const _submitForm = async () => {
    if (isLoading) return;
    const didSubmit = await manuallySubmit();
    if(didSubmit) {
      actions.setPage(state.session.isPreorder ? 'presale-notify-complete' : 'order-complete');
    }
  };

  const chooseType = (type) => {
    actions.update({payment: type});

    dataLayerPush({
      'event':'payment_change',
      'paymentType': type
    });
  }

  const paymentTypes = [
    {
      type: 'checking',
      name: 'Checking Acct',
      cost: 'Preferred - No Fees',
    },
    {
      type: 'credit',
      name: 'Credit Card',
      cost: '$2.50/transaction',
    },
    {
      type: 'mail',
      name: 'Bill Me',
      cost: '$5.00/month',
    },
  ];

  const range = (start, end) => {
    return Array(end - start + 1).fill().map((_, idx) => start + idx);
  }

  // const expMonths = range(1, 12).map(i => i.toString().padStart(2, '0'));
  const expMonths = [
    '01 - Jan',
    '02 - Feb',
    '03 - Mar',
    '04 - Apr',
    '05 - May',
    '06 - Jun',
    '07 - July',
    '08 - Aug',
    '09 - Sept',
    '10 - Oct',
    '11 - Nov',
    '12 - Dec',
  ];

  const currentMonthNumber = new Date().getMonth()+1;
  const currentYear = new Date().getFullYear();
  // if we put in a month that is before the current month, require them to have a future expiration year
  const expYearStart = getValues('exMonth') && parseInt(getValues('exMonth')) < currentMonthNumber ? currentYear+1 : currentYear;
  const expYears = range(expYearStart, currentYear+10).map(i => i.toString());

  const canGoToNext = state.session.payment != '' && (state.session.payment === 'mail' || isValid);

  return (<>
        <HeaderBar backPage={'order-customer'} /*nextPage={state.session.isPreorder ? 'presale-notify-complete' : 'order-complete'} nextPageLoading={isLoading} nextPageEnabled={canGoToNext} nextPageAction={manuallySubmit}*/>
          <h1 className="bigger">Payment Options</h1>
          <p>Payment will process 24 hours prior to your installation date</p>
        </HeaderBar>

        <div className="mt-4 grid grid-flow-row-dense grid-cols-1 md:grid-cols-3 gap-4">
          {paymentTypes.map((t,i) => (
            <div key={i}>
              <ContentButton className="flex-1 flex flex-col gap-4 items-center justify-center pt-2 pb-2" isActive={state.session.payment === t.type} onClick={()=>chooseType(t.type)}>
                <div>
                  <p className="text-2xl font-bold !leading-none">{t.name}</p>
                </div>
              </ContentButton>
              <p className={`text-xs text-center !mt-1 ${state.session.payment === t.type ? 'text-blue-400' : ''}`}>{t.cost}</p>
            </div>
          ))}
        </div>

        <div className="mt-4">
          <form onSubmit={handleSubmit(updateData)} className={`grid grid-flow-row-dense gap-4 ${state.session.payment == 'credit' ? 'grid-cols-2 md:grid-cols-5' : 'grid-cols-1 md:grid-cols-2'}`}>

            {state.session.payment === 'checking' && (<>
              <input type="number" placeholder="Checking Acct Number" {...register("account", {required: 'Checking account nubmer is required'})}/>
              <input type="number" placeholder="Routing Number" {...register("routing", {required: 'Routing number is required'})}/>
              <input placeholder="Financial Institution" {...register("bank", {required: 'Financial institution is required'})}/>
              <select {...register("type", {required: 'Account type is required'})} defaultValue={''}>
                  <option value="" disabled>Account Type</option>
                  <option value="PC">Personal Checking</option>
                  <option value="BC">Business Checking</option>
              </select>
              </>)}

              {state.session.payment === 'credit' && (<>
                {/* <input className="col-span-2 md:col-span-3" type="number" placeholder="Credit Card Number" {...register("ccard", {required: true})}/> */}

                {/*
                <svg {...getCardImageProps({ images })} />
                <input {...getCardNumberProps()} />
                <input {...getExpiryDateProps()} />
                <input {...getCVCProps()} />
                {meta.isTouched && meta.error && <span>Error: {meta.error}</span>}
                */}

                <input
                  className="col-span-2 md:col-span-3"
                  type="text"
                  placeholder="Credit Card Number"
                  {...withHookFormMask(register("ccard", {required: true}), [getValues('ccard').match('^3[47]') ? '9{4} 9{6} 9{5}' : '9{4} 9{4} 9{4} 9{4}'])}
                />

                <select className="col-span-1" {...register("exMonth", {required: true})}>
                    <option value="">MM</option>
                    {expMonths.map(m => {
                      const mnum = m.split(' - ')[0];
                      return (<option key={mnum} value={mnum}>{m}</option>)
                    })}
                </select>
                <select className="col-span-1" {...register("exYear", {required: true})}>
                    <option value="">YY</option>
                    {expYears.map(y => (<option key={y} value={y}>{y}</option>))}
                </select>
              </>)}

              {state.session.payment === 'mail' && (<>
                <div className="col-span-2 w-full max-w-xl mx-auto">
                  <p>Please continue with this option if you prefer to make manual payments, or if you're just more comfortable discussing your billing options when we call you to confirm your installation.</p>
                  <p className="!mt-4">Please note- Payments made using a credit card have an additional $2.50 transaction fee. We do allow for manual ACH payments with Checking account information with no additional transaction fee.</p>
                </div>
              </>)}

              <div className="col-span-full">
                <Button className="sm:inline-block" size="large" color="purple" loading={isLoading} enabled={canGoToNext && !isLoading} onClick={() => {!isLoading && canGoToNext && _submitForm()}}>Submit</Button>
              </div>

            {errorMessage.message != '' && (
            <div className="col-span-full">
              <div className="bg-red-50 border-[1px] border-red-100 rounded mt-4 p-4 text-left shadow">
                {errorMessage.title != '' && (<b>{errorMessage.title}</b>)}
                <p>{errorMessage.message}</p>
              </div>
            </div>
            )}

          </form>
        </div>

    </>)

};

export default OrderPayment;